import { render, staticRenderFns } from "./genericAchievement.vue?vue&type=template&id=b97b22d6&scoped=true&"
import script from "./genericAchievement.vue?vue&type=script&lang=js&"
export * from "./genericAchievement.vue?vue&type=script&lang=js&"
import style0 from "./genericAchievement.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./genericAchievement.vue?vue&type=style&index=1&id=b97b22d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97b22d6",
  null
  
)

export default component.exports